/**
 * Shared Clerk <SignIn /> / <SignUp /> appearance.
 * Applied globally via ClerkProvider so every modal — public auth, AdminAuth,
 * user profile — matches the FFA dark theme.
 */
import { isNative } from "@/lib/platform";


export const clerkAppearance = {
  variables: {
    colorPrimary: "hsl(142, 71%, 45%)",
    colorBackground: "hsl(222, 47%, 8%)",
    colorInputBackground: "hsl(222, 40%, 12%)",
    colorInputText: "hsl(210, 40%, 98%)",
    colorText: "hsl(210, 40%, 98%)",
    colorTextSecondary: "hsl(215, 16%, 65%)",
    colorDanger: "hsl(0, 84%, 60%)",
    colorSuccess: "hsl(142, 71%, 45%)",
    borderRadius: "0.75rem",
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  elements: {
    rootBox: "w-full max-w-sm mx-auto",
    card:
      "bg-card/95 backdrop-blur-md border border-primary/20 shadow-2xl shadow-primary/10 rounded-2xl p-4 sm:p-5",
    headerTitle: "!text-white text-lg sm:text-xl font-bold",
    headerSubtitle: "!text-white/80 text-xs sm:text-sm",
    socialButtonsBlockButton:
      "bg-secondary/40 border border-border hover:bg-secondary !text-white transition-all py-2",
    socialButtonsBlockButtonText: "!text-white font-medium",
    dividerLine: "bg-border",
    dividerText: "!text-white/70 text-xs",
    formFieldLabel: "!text-white text-sm font-medium",
    formFieldInput:
      "bg-input border border-border !text-white placeholder:!text-white/40 rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary py-2",
    formButtonPrimary:
      "bg-gradient-to-r from-primary to-green-600 hover:from-primary/90 hover:to-green-700 !text-white font-semibold shadow-lg shadow-primary/30 normal-case py-2",
    footerActionLink: "!text-primary hover:!text-primary/80 font-medium",
    footer: "bg-card/80 border-t border-border",
    footerAction: "!text-white/80",
    identityPreviewText: "!text-white",
    identityPreviewEditButton: "!text-primary",
    formFieldSuccessText: "text-green-400",
    formFieldErrorText: "text-red-400",
    otpCodeFieldInput: "border-border bg-input !text-white",
    footerPagesLink: "!text-white/70 hover:!text-white",
    // Terms & conditions consent — keep it clearly visible on the dark theme.
    formFieldRow__legalAccepted: "flex items-start gap-2 !text-white opacity-100 visible",
    formFieldLabel__legalAccepted: "!text-white text-xs leading-snug",
    formFieldCheckboxInput:
      "!appearance-auto w-4 h-4 shrink-0 !opacity-100 accent-[hsl(142,71%,45%)] border border-white/40 bg-input rounded",
    formFieldCheckboxLabel: "!text-white text-xs leading-snug",
    formFieldInfoText: "!text-white/70 text-xs",
    userButtonPopoverCard: "!bg-card !text-white",
    userButtonPopoverActionButton: "!text-white hover:!bg-primary/10",
    userButtonPopoverActionButtonText: "!text-white",
    userPreviewMainIdentifier: "!text-white",
    userPreviewSecondaryIdentifier: "!text-white/70",
    logoBox: "hidden",

    // Native (Capacitor) only: hide social sign-in — native uses email + name
    // from Clerk. Web and mobile web keep the Google button.
    ...(isNative
      ? {
          socialButtons: "hidden",
          socialButtonsBlockButton: "hidden",
          socialButtonsIconButton: "hidden",
          socialButtonsProviderIcon: "hidden",
          dividerRow: "hidden",
          alternativeMethodsBlockButton__google: "hidden",
        }
      : {}),
  },
} as const;

